/* eslint-disable @typescript-eslint/no-explicit-any */
import { print } from 'graphql';
import { APP_HEADERS } from './constants';

export async function graphqlFetch<TData, TVariables>(
  query: any,
  variables?: TVariables,
): Promise<TData> {
  const token = localStorage.getItem('authToken');
  const response = await fetch(process.env.REACT_APP_API_URL || '', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/graphql-response+json',
      Authorization: token ? `Bearer ${token}` : '',
      ...APP_HEADERS,
    },
    body: JSON.stringify({
      query: print(query),
      variables,
    }),
  });

  const { data, errors } = await response.json();

  if (errors) {
    throw new Error(errors.map((error: any) => error.message).join(', '));
  }

  return data;
}
